import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountAppointmentsQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countAppointments(options: { filters: $filters })
      }
    }
  }
`
